module.exports = __webpack_public_path__ + "img/墨西哥.1f169869.png";